export { default as RichMenuTable } from "./RichMenuTable.vue"